var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields"},[_vm._l((_vm.rows),function(row){return [_vm._l((row),function(field,key){return [(
          field.type !== 'contentGroup' &&
          field.type !== 'content' &&
          field.type !== 'custom' &&
          !_vm.isContentType({
            id: field.id,
            category: field.category || _vm.category,
          }) &&
          !_vm.isObjectType({
            id: field.id,
            category: field.category || _vm.category,
          })
        )?_c('field',{key:field.id && _vm.configTemplate
            ? _vm.getFieldId({
                id: field.id,
                category: field.category || _vm.category,
              })
            : key,attrs:{"field":field,"bulkDelete":_vm.bulkDelete,"parentField":_vm.parentField,"category":field.category || _vm.category}}):_vm._e(),(field.type === 'custom')?_c('customFields',{key:field.id && _vm.configTemplate
            ? _vm.getFieldId({
                id: field.id,
                category: field.category || _vm.category,
              })
            : key,attrs:{"id":field.id,"bulkDelete":_vm.bulkDelete,"category":field.category || _vm.category,"field":field.field}}):_vm._e(),(field.type === 'contentGroup')?[_vm._l((field.items),function(field){return [(
              field.type === 'config' &&
              !_vm.isContentType({
                id: field.id,
                category: field.category || _vm.category,
              })
            )?_c('field',{key:field.id && _vm.configTemplate
                ? _vm.getFieldId({
                    id: field.id,
                    category: field.category || _vm.category,
                  })
                : key,attrs:{"field":field,"bulkDelete":_vm.bulkDelete,"parentField":_vm.parentField,"category":field.category || _vm.category}}):_vm._e()]})]:_vm._e(),(
          _vm.isObjectType({
            id: field.id,
            category: field.category || _vm.category,
          })
        )?_c('div',{key:field.id && _vm.configTemplate
            ? _vm.getFieldId({
                id: field.id,
                category: field.category || _vm.category,
              })
            : key},[(
            _vm.bulkDelete ||
            (_vm.configVisibility['bulkEdit'] &&
              _vm.configVisibility['bulkEdit'][field.category || _vm.category] &&
              _vm.configVisibility['bulkEdit'][field.category || _vm.category][
                field.id
              ])
          )?_c('p',{staticClass:"object-label subtitle-2"},[_vm._v("\n          "+_vm._s(_vm.getFieldValue({
              value: "label",
              id: field.id,
              category: field.category || _vm.category,
            }))+"\n        ")]):_vm._e(),_c('fields',{staticClass:"object",attrs:{"rows":field.layout,"category":field.category || _vm.category,"parentField":field.id,"id":field.id,"bulkDelete":_vm.bulkDelete}})],1):_vm._e()]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }